import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useMeQuery } from '@generated/graphql';
import { useTranslation } from 'react-i18next';
import { $user, $userError, $userLoading, setUser, setUserError, setUserLoading } from './model';

const useMe = () => {
  const { i18n } = useTranslation();
  const { data, loading: meLoading, error: meError } = useMeQuery();
  const [me, loading, error] = useUnit([$user, $userLoading, $userError]);

  useEffect(() => {
    if (data?.me.language && i18n.language !== data?.me.language) {
      i18n.changeLanguage(data?.me.language);
    }
    setUserLoading(meLoading);
    setUserError(meError || null);
    setUser(meLoading || meError ? null : data?.me || null);
  }, [data, meLoading, meError]);

  return {
    me,
    loading,
    error,
  };
};

export default useMe;
